// Resolve a server-sent survey key into the verbatim question array from surveyQuestions_v2.
import * as S from './surveyQuestions_v2'

const DOMAIN_LABEL = {
  concurrency: "Trio's concurrency features (nurseries, starting tasks, running functions at the same time)",
  error_handling: "Trio's error-handling features (handling failures inside concurrent tasks)"
}
const TASK_LABEL = {
  a1: 'the concurrency task',
  b1: 'the error-handling task',
  transfer_immediate: 'the transfer task',
  transfer_delayed: "today's task"
}

// Modal width, derived from the questions rather than listed by key — a new survey gets
// the right width for free.
//
//   xl  long answer options. At a narrower width they wrap to two lines each, so five
//       options cost ten and the card grows tall enough to scroll.
//   ml  any 1–7 scale. The row is [min label][7 buttons][max label] and must not wrap:
//       a wrapped max label lands at the START of the next line, under the min label,
//       inverting the scale. 560px is too tight for it; 660 fits it with a small margin.
const LONG_OPTION = 44

export function surveyModalSize (key, hasIntro) {
  const qs = resolveSurvey(key)
  const longOptions = qs.some(q =>
    (q.type === 'multiple_choice' || q.type === 'radio') &&
    (q.options || []).some(o => String(o).length > LONG_OPTION))
  if (longOptions) return 'xl'
  // An intro means a page of framing copy to read, which wants the wider measure even
  // if the questions below it are scales.
  if (qs.some(q => q.type === 'scale')) return hasIntro ? 'lg' : 'ml'
  return hasIntro ? 'lg' : 'md'
}

export function resolveSurvey (key) {
  if (!key) return []
  if (key.startsWith('taskDifficulty:')) {
    const t = key.split(':')[1]
    return S.taskDifficulty(t, TASK_LABEL[t] || 'this task')
  }
  if (key.startsWith('probePre:')) {
    const d = key.split(':')[1]
    return S.probePre(DOMAIN_LABEL[d] || d)
  }
  return S[key] || []
}
